/**
=========================================================
* Soft UI Dashboard React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";


import { useSoftUIController } from "context";
import {useState, useEffect} from 'react';
import moment from 'moment';

// Soft UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MiniStatisticsCard from "examples/MiniStatisticsCard";

// Dashboard layout components
import UnassignedTasks from "layouts/dashboard/components/UnassignedTasks";
import ActiveDrivers from "layouts/dashboard/components/ActiveDrivers";

function Dashboard() {
  const [controller, dispatch] = useSoftUIController();
  const { drivers, deliveries, pickups, selectedDriver, currentDate, user } = controller;
  const [ divisionDeliveries, setDivisionDeliveries] = useState([]);
  const [ divisionPickups, setDivisionPickups ] = useState([]);
  const activeDrivers = drivers.filter(d => (deliveries.find(ds => ds.driver === d.email) || pickups.find(ps => ps.driver === d.email)));
  const idleDrivers = drivers.filter(d => d.driver && !activeDrivers.find(ad => ad.email === d.email));

  useEffect(() => {
    if(user)
    {
      setDivisionDeliveries(deliveries.filter(d => user.shipFrom === 'PGH' ? d.deliveryMethod === 'FEI Delivery' : d.deliveryMethod === `${user.shipFrom} - FEI Delivery`));
      setDivisionPickups(pickups.filter(p => p.division === user.shipFrom));    
    }    
  }, [user])

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: ((currentDate.startOf('day').isSame(moment().startOf('day'))) ? "Today's" : currentDate.format("MMM Do")) + " Deliveries" }}
                count={deliveries.length}
                icon={{ color: "info", component: "directions_bus" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: ((currentDate.startOf('day').isSame(moment().startOf('day'))) ? "Today's" : currentDate.format("MMM Do")) + " Pickups" }}
                count={pickups.length}
                icon={{ color: "info", component: "view_in_ar" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Active Drivers" }}
                count={activeDrivers.length}
                icon={{ color: "info", component: "people" }}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={3}>
              <MiniStatisticsCard
                title={{ text: "Idle Drivers" }}
                count={idleDrivers.length}
                icon={{ color: "info", component: "people_outline" }}
              />
            </Grid>
          </Grid>
        </SoftBox>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
                <UnassignedTasks drivers={drivers} deliveries={deliveries} pickups={pickups} selectedDriver={selectedDriver} />           
            </Grid>
          </Grid>
        </SoftBox>              
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
                <ActiveDrivers drivers={drivers} deliveries={deliveries} pickups={pickups} selectedDriver={selectedDriver} />           
            </Grid>
          </Grid>
        </SoftBox>              
      </SoftBox>
    </DashboardLayout>
  );
}

export default Dashboard;
